import { http } from "./api-config";
import store from "../store";

const apiDocumentClient = http(process.env.VUE_APP_DOCUMENT_SERVICE)
export default {
    
    async createDirectory(data) {
        const res = await apiDocumentClient.post('directory', data)
        return res.data
    },
    async updateDirectory(data) {
        const res = await apiDocumentClient.put('directory', data)
        return res.data
    },
    async getDirectoryList() {
        let headers = {};
        if (store.state.variables.cashDirectoryList) {
            headers = { "isSilentAPI": true };
        }
        store.commit('variables/setCashDirectoryList', true)
        const res = await apiDocumentClient.get('directorylist', { headers })
        return res.data
    },

    async getDirectory(id) {
        const res = await apiDocumentClient.get(`directory/${id}`)
        return res.data
    },

    async deleteDirectory(id) {
        const res = await apiDocumentClient.delete(`directory/${id}`)
        return res.data
    },
    async deleteDirectories(data) {
        const res = await apiDocumentClient.put('deletedirectories', data)
        return res.data
    },
}